import {memo} from 'react'

import type {BuildId} from '../../../../types'
import BuildArtifactsTree from '../../../common/BuildArtifactsTree/BuildArtifactsTree'

type Props = {
  buildId: BuildId
}

function BuildArtifactsTab({buildId}: Props) {
  return (
    <BuildArtifactsTree
      autoWidth
      urlSync
      showToggleHidden
      showDownloadLink
      showStorageInfo
      canSelectDirs
      buildId={buildId}
    />
  )
}

export default memo<Props>(BuildArtifactsTab)
